import * as dataListApi from "../../_api/dataListApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadHearAbout() {
  return function (dispatch) {
    dispatch(beginApiCall());

    return dataListApi
      .getHearAbout()
      .then((hearAbout) => {
        return hearAbout;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
